<script>
  import Hls from 'hls.js';

  export default{
    name : 'CpTvPage',
    directives : {
      margin: require('../directives/margins').margin,
      marginBottom: require('../directives/margins').marginBottom,
      marginTop: require('../directives/margins').marginTop,
    },
    components:{
      CpBox : require('../box').default,
      CpBoxContent : require('../box-content').default,
      CpGrid : require('../grid').default,
      CpGridItem: require('../grid-item').default,
      CpButtonLink : require('../button-link').default,
      CpHomeRallyBanner : require('../rallies/home-rally-banner').default,
      CpSocialShareDialog:require('../dialogs/social-share').default,
    },
    data(){
      return{

      }
    },
    props : {
      rallyInCourse: {type: Boolean, default: false},
      videoSource : {type:String, default : "https://res.cloudinary.com/crowdpac/video/upload/v1585409205/assets/videos/CrowdpacCandidateTV-1080.mp4"},
      explore: {type: Boolean, default: false},
      rally: Object,
    },
    mounted(){
      let video = document.getElementById('tv-player');
      if (video && this.rallyInCourse === false){ //play default video
        video.src = this.videoSource;
        video.type = "video/mp4";
        video.addEventListener('loadedmetadata', function() {
            video.play();
        });
      } else if (this.rallyInCourse === true) {
        if (this.rally && this.rally.stream_url == null || this.rally.stream_url.length == 0) {
            if (Hls && Hls.isSupported()) {
                var hls = new Hls({ autoStartLoad: true, capLevelToPlayerSize: true, maxBufferLength: 10, maxLoadingDelay: 3 });
                hls.loadSource('https://live-dist.global.ssl.fastly.net/tdlive/crowdpac.smil/playlist.m3u8');
                hls.attachMedia(video);
                hls.on(Hls.Events.MANIFEST_PARSED, function() {
                    video.play();
                });
                hls.on(Hls.Events.ERROR, function (event, data) {
                    if (data.fatal) {
                        switch(data.type) {
                        case Hls.ErrorTypes.NETWORK_ERROR:
                            hls.startLoad();
                            break;
                        case Hls.ErrorTypes.MEDIA_ERROR:
                            hls.recoverMediaError();
                            break;
                        default:
                            hls.destroy();
                            break;
                        }
                    }
                });
            } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
                video.src = 'https://live-dist.global.ssl.fastly.net/tdlive/crowdpac.smil/playlist.m3u8';
                video.addEventListener('loadedmetadata', function() {
                    video.play();
                });
            }
        }
      }
    }
  }
</script>

<template>
    <div v-if="explore && rallyInCourse">
        <video controls="true" id="tv-player" style="width:100%;height:auto; min-height:300px;" class="rally-player" />
    </div>
    <cp-box v-else>
        <cp-box-content>
            <cp-grid>
            </cp-grid>
            <cp-grid>
                <cp-grid-item  :span="$root.isMobile ? 0 : 1 ">
                </cp-grid-item>
                <cp-grid-item  :span="$root.isMobile ? 12 : 8 ">
                    <template v-if="rallyInCourse === true">
                        <video v-if="rally && rally.stream_url == null || rally.stream_url.length == 0" controls="true" id="tv-player" style="width:100%; height:auto; min-height:300px; margin-top:20px;" class="rally-player" />
                        <iframe
                            v-else
                            width="560"
                            height="420"
                            class="rally-player"
                            :src="'https://www.youtube.com/embed/' + rally.stream_url"
                            frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowfullscreen
                        ></iframe>
                    </template>
                    <div v-else id="crowdpac-tv-player-wrapper" style="position: relative;padding-bottom: 56.25%;height: 0;" class="rally-player">
                        <iframe style="position: absolute;top: 0;left: 0;width: 100%;height: 100%;" src="https://www.youtube.com/embed/videoseries?list=PL4ZqmxF97SAFCamouyKXQfywQsi7MQ-pj&autoplay=1&loop=1" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen>
                    </iframe>
                    </div>
                    <div class="heading-1 color-black feature-icon--title" style="margin-top: calc(var(--gutter) * 0.8); margin-bottom: calc(var(--gutter) * 0.5);">
                      CrowdBlue T.V.
                    </div>
                    <p>Our central T.V. station where all virtual campaign rallies are played.</p>
                </cp-grid-item>
                <cp-grid-item  :span="$root.isMobile ? 12 : 2 ">
                    <div class="heading-2 color-black feature-icon--title" block style="text-align:center; margin-top: calc(var(--gutter) * 0.8); margin-bottom: calc(var(--gutter) * 0.5);">
                        Ready to go live ?
                    </div>
                    <cp-button-link
                    :href="'/user/rallies'"
                    block
                    >
                        Create A Virtual Rally</span>
                    </cp-button-link>
                </cp-grid-item>
                <cp-grid-item  :span="$root.isMobile ? 0 : 1 ">
                </cp-grid-item>
            </cp-grid>
        </cp-box-content>
    </cp-box>
</template>
<style>
  .rally-player {
    border-radius: 6px;
    background-color: #000000;
    width: 100%;
  }
  video:focus{
    outline:none;
  }
</style>
